export const env = {
    "msalClientId": "2180e4db-6063-48fb-bc58-7702dfac58b1",
    "b2cTenant": "benderb2cprd.onmicrosoft.com",
    "b2cLoginDomain": "login.connect.bender-group.com",
    "frontDoorUrl": "https://connect.bender-group.com",
    "webComponentsContainerEndpoint": "https://stcmphorizontalweuprd.blob.core.windows.net/components"
};
//# sourceMappingURL=env.js.map